module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Notifications1-80cc0ed4f334b24791109ea37deb7541.svg";